import React, { useCallback } from 'react';
import * as Styles from './ChooseSiteOption.styles';
import {
  Button,
  IconAiStar,
  IconArrow,
} from 'gatorcomponents';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';

const ChooseSiteOption = ({
  title,
  options,
  haveExperienceLabel,
  ctaAdvancedMode,
}) => {
  const stepProps = useCallback(() => ({
    title,
    testId: 'choose-wp-migration-step',
    contentWidthFlexible: true,
    centerContent: false,
  }), [
    title,
  ]);

  return (
    <Styles.Wrapper>
      <GenericStep {...stepProps()}>
        <Styles.OptionsWrapper>
          {options.map(option => (
            <Styles.ListItem key={option.id}>
              <Styles.ImageWrapper>
                <img src={option.image.src} alt={option.image.alt} />
              </Styles.ImageWrapper>
              <Styles.ContentWrapper>
                <Styles.OptionRow>
                  <Styles.TitleRow>
                    <Styles.IconAdapter>
                      {option.iconTitle}
                    </Styles.IconAdapter>
                    <Styles.TitleAdapter>
                      <Styles.OptionTitle>
                        {option.title}
                      </Styles.OptionTitle>
                      {option.recommended && (
                        <Styles.TagWrapper>
                          <Styles.TagText>{option.recommended}</Styles.TagText>
                        </Styles.TagWrapper>
                      )}
                    </Styles.TitleAdapter>
                    <Styles.Subtitle>
                      {option.subtitle}
                    </Styles.Subtitle>
                  </Styles.TitleRow>
                </Styles.OptionRow>
                <Styles.OptionRow>
                  <Styles.OptionDescription>
                    {option.description}
                  </Styles.OptionDescription>
                </Styles.OptionRow>
                <Styles.OptionRow>
                  <Button
                    variant="primary"
                    onClick={option.cta.action}
                    label={(
                      <Styles.BtnAdapter>
                        {option.cta.label}
                        <IconAiStar size="sm" color="highPure" />
                      </Styles.BtnAdapter>
                    )}
                    testId={`option-${option.id}-cta`}
                    width="full"
                    size="medium2"
                    version="v2"
                    padding="20px 0 0 0"
                  />
                </Styles.OptionRow>
                <Styles.OptionRowLast>
                  <Styles.OptionSubDescription>
                    {option.footerLabel}
                  </Styles.OptionSubDescription>
                  {option.ctaFooter && (
                    <Button
                      variant="text"
                      onClick={option.ctaFooter.action}
                      iconRight={<IconArrow direction="right" />}
                      label={option.ctaFooter.label}
                      testId={`option-${option.id}-cta-footer`}
                    />
                  )}
                </Styles.OptionRowLast>
              </Styles.ContentWrapper>
            </Styles.ListItem>
          ))}
          <Styles.FooterText>
            {haveExperienceLabel}
            <Button
              variant="text"
              onClick={ctaAdvancedMode && ctaAdvancedMode.action}
              iconRight={<IconArrow direction="right" />}
              label={ctaAdvancedMode && ctaAdvancedMode.label}
              testId="cta-advanced-mode"
            />
          </Styles.FooterText>
        </Styles.OptionsWrapper>
      </GenericStep>
    </Styles.Wrapper>
  );
};

export default ChooseSiteOption;
